<google-map [center]="markerPosition">
    <map-marker [position]="markerPosition" [icon]="icon"></map-marker>
    <map-marker *ngIf="schlachthofPosition" [position]="schlachthofPosition"></map-marker>
</google-map>
